/**
 * ページ上部にスムーススクロールで移動
 * ハッシュ付きリンクのスムーススクロールの用途限定版
 * https://github.com/tsuyoshiwada/sweet-scroll
 */
import SweetScroll from 'sweet-scroll';
var baseName = '#goPageTop';
var headerElement = '[data-scroll-header]'; // 固定ヘッダの CSS セレクタ

document.addEventListener('DOMContentLoaded', function () {
  var goPageTop = new SweetScroll({
    trigger: baseName,
    // トリガとなる要素を CSS セレクタで指定
    header: headerElement,
    // 固定ヘッダを CSS セレクタで指定
    duration: 1000,
    // アニメーション再生時間のミリ秒
    easing: 'easeOutQuint',
    // イージングのタイプ
    offset: 0,
    // スクロール位置のオフセット
    vertical: true,
    // 垂直方向のスクロールの可否
    horizontal: false,
    // 水平方向のスクロールの可否
    cancellable: true,
    // ホイールやタッチイベントによるスクロールの停止可否
    updateURL: false,
    // スクロール完了後に URL を更新する
    preventDefault: true,
    // コンテナ要素のクリックイベント防止
    stopPropagation: true // コンテナ要素のバブリング防止

  });
});